/**
 * @desc 商户活动页面
 */
export default {
  // 获取活动商品
  getActiveProduct: {
    url: '/mp/item/activities/activitiesRelationId',
    method: 'GET'
  },
  // 获取配置的活动详细信息
  getActiveDetail: {
    url: '/mp/global/groundTemplate/templateId',
    method: 'GET'
  },
   // 获取详细信息
   getGoodsDetail: {
    url: '/mp/item/itemDesc',
    method: 'GET'
  },
   // 获取订单支付信息
   getPaymentStatus: {
    url: '/mp/order/getPaymentStatus',
    method: 'POST'
  },
   // 订单支付
   cashierRepayOff: {
    url: '/mp/order/cashierRepayOff',
    method: 'POST'
  },
   // 用于创建商户入驻注册信息
   merchantRegister: {
    url: '/mp/member/merchant/register',
    method: 'POST'
  },
   // 商户入驻注册信息上传
   merchantUpload: {
    url: '/mp/member/merchant/upload',
    method: 'POST'
  }
};
